import { RouteObject } from'react-router-dom';
import { CreateServiceRequest } from './components/create/CreateServiceRequest';

export const serviceRoutes: RouteObject[] = [
 {
 path:'create/service',
 element: <CreateServiceRequest />,
 }
];
